import "./OurPeople.module.css";
import Header from "@/reusable_sections/Header";
import MeetTheChocolatier from "./sections/MeetTheChocolatier";
import OurExpertClinicians from "./sections/OurExpertClinicians";
import OurPrestigePartners from "./sections/OurPrestigePartners";
import Footer from "@/reusable_sections/Footer";
export default function OurPeoplePage() {
  return <div>
      <Header />
      <MeetTheChocolatier />
      <OurExpertClinicians />
      <OurPrestigePartners />
      <Footer />
    </div>;
}